import { Toast } from 'primereact/toast'
import { useEffect, useRef } from 'react'
import { useAppSelector } from '../../store'

const ToastComponent: React.FC = () => {
  const toastRef = useRef<Toast | null>(null)

  const { toast } = useAppSelector((state) => state.layout)

  useEffect(() => {
    if (toastRef.current && toast)
      toastRef.current.show({
        severity: toast.severity,
        detail: toast.summary ? toast.summary : '',
        life: toast.life || 3000,
        closable: toast.closable,
      })
  }, [toast])

  return <Toast ref={toastRef} position="bottom-right" />
}

export default ToastComponent
